import { render, staticRenderFns } from "./purchase-history.vue?vue&type=template&id=49e4a02e&scoped=true&"
import script from "./purchase-history.vue?vue&type=script&lang=js&"
export * from "./purchase-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e4a02e",
  null
  
)

export default component.exports